import { isEmpty } from "lodash";
import { Typography } from "PFComponents/typography";
import { MatchedActivity } from "PFTypes";
import React from "react";
import { useTranslation } from "react-i18next";

import { Section } from "../../components";

type StatementSectionProps = {
  role: MatchedActivity["activity"];
};

export const StatementSection = ({ role }: StatementSectionProps): JSX.Element | null => {
  const { t } = useTranslation("marketplace", {
    keyPrefix: "workOpportunities.roleDetails.statement"
  });

  const statementOfQualification = role.interest_details?.statement;

  if (isEmpty(statementOfQualification)) {
    return null;
  }

  return (
    <Section title={t("title")}>
      <Typography variant="bodyRegular" noMargin>
        {statementOfQualification}
      </Typography>
    </Section>
  );
};
